<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title--Front-Matter-">Inspector French and the Starvel Hollow Tragedy</p>
<p class="ORIM-Chapter-Subtitle--Body-">An Inspector French Mystery</p>
<p class="ORIM-Author-Name--Front-Matter-">Freeman Wills Crofts</p>
<p class="ORIM-Author-Name--Front-Matter-"><img src="image/logo2.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?2c076804